import { PropsWithChildren, useMemo } from 'react';

import { XYChartAnnotationsShownIndicatorsContext } from '../context/XYChartAnnotationsShownIndicators.context.js';
import { useXYChartAnnotationsIndicators } from '../hooks/useXYChartAnnotationsIndicators.js';
import { useAnnotationsState } from '../store/selectors.js';

export const XYChartAnnotationsShownIndicatorsProvider = ({
  children,
}: PropsWithChildren) => {
  const { alwaysVisible, selectable } = useXYChartAnnotationsIndicators();
  const { hoveredGroup } = useAnnotationsState();

  const shownIndicators = useMemo(() => {
    if (hoveredGroup && selectable.has(hoveredGroup)) {
      const hoveredIndicator = selectable.get(hoveredGroup);
      if (hoveredIndicator) {
        return [hoveredIndicator, ...alwaysVisible];
      }
    }
    return alwaysVisible;
  }, [hoveredGroup, alwaysVisible, selectable]);

  return (
    <XYChartAnnotationsShownIndicatorsContext.Provider value={shownIndicators}>
      {children}
    </XYChartAnnotationsShownIndicatorsContext.Provider>
  );
};
